import { observer } from "mobx-react-lite";

import { useNodeThemeColors } from "@/components/expression/theme/useNodeTheme";
import { useNodeStyle } from "@/components/expression/utils/NodeStyleProvider";
import { twMerge } from "@/utils/twMerge";

import TildeIcon from "./icons/Tilde.svg";

import type { DecoratorNodeModel } from "@/models/nodes/DecoratorNodeModel";

type Props = {
  node: DecoratorNodeModel;
};

export const Tilde = observer(function Tilde({ node }: Props) {
  const { parent: symbolNode } = node;
  const { view, size } = useNodeStyle();
  const theme = useNodeThemeColors(symbolNode?.parent);
  const isTextView = view === "text";

  return (
    <div
      className={twMerge(
        "absolute -top-[0.12rem] left-0 w-full flex justify-center",
        isTextView && size === "xxs" && "top-0",
        isTextView && size === "xxxs" && "-top-[0.1rem]",
      )}
    >
      <TildeIcon
        className={twMerge(
          "stroke-document-text",
          theme?.symbol && `stroke-${theme.symbol.light} dark:stroke-${theme.symbol.dark}`,
        )}
      />
    </div>
  );
});
